import React, { Component, useState, useContext } from "react";
import {useChangeLang, IsAuthContext} from '../../App';
import { useTranslate } from 'react-redux-multilingual'
import { useForm } from "react-hook-form";
import axios from 'axios'
import { useCookies} from 'react-cookie';
import { Redirect } from "react-router-dom";

const Signin = () => {
  const [lang,langToggle] = useChangeLang()
  const [validButton,setValidButton] = useState(false)
  const [generalError,setGeneralError] = useState(false)
  const [redirect, setRedirect] = useState(false)
  const [cookies, setCookie] = useCookies(['end_session'])
  const t = useTranslate();
  const { register, formState: { errors }, handleSubmit } = useForm();
  const { setAuthParam } = useContext(IsAuthContext)

  const onSubmit = async (data) => {
    setValidButton(true)
    setGeneralError(false)
    const uninterceptedAxiosInstance = axios.create();
    const response  = await uninterceptedAxiosInstance.post(process.env.REACT_APP_API_URL+"api/auth/login", {
      email: data.email,
      password: data.password
    },{withCredentials: true}).then((response) => {
      localStorage.setItem('jwt_token', response.data.token);
      localStorage.setItem('auth_user', response.data.user.id)
      setAuthParam({
        isauth:true,
        userid:response.data.user.id,
        user: response.data.user.name,
        company: response.data.user.company,
        modules: response.data.user.module,
        roles: response.data.user.role,
        sections: response.data.user.section,
        access:response.data.user.access
      });
      if(cookies.end_session){
        //si la session à expirée, un cookie de 5 minutes avec la derniere url sera créé
        //si on se reconnecte dans le temps, on sera redirigé vers la derniere url, sinon vers la page d'accueil 
        setRedirect(cookies.end_session)
      }else{
        setRedirect("/welcome/welcome")
      }
    }).catch((error) => {
      if(error=='end_session') return;
      if(!error.response){
          setGeneralError(t('unknowError'))
      }
      else if(error.response.status===401){
          setGeneralError(t('identFailed'))
      }
      else {
          setGeneralError(t('unknowError'))
      }
    })
    setValidButton(false)
  }

  if(redirect){
    return (<Redirect to={redirect} />)
  }

  return(
    <div
      className="auth-layout-wrap"
      style={{
        backgroundImage: "url(/assets/images/fond.jpg)",
      }}
    >
      <div className="auth-content">
        <div className="card o-hidden" style={{backgroundColor:"rgba(255,255,255)"}}>
          <div className="row">
            <div className="col-md-6" style={{backgroundColor:"rgba(255,255,255)"}}>
              <div className="p-4">
                <h1 className="mb-3 text-18">{t('signIn')}</h1>
                <form onSubmit={handleSubmit(onSubmit)}>
                  <div className="form-group">
                    <label htmlFor="email">Email</label>
                    <input
                      className="form-control form-control-rounded position-relative"
                      type="email"
                      id="email"
                      {...register("email", { required: true})}
                    />
                    {errors.email?.type === 'required' && (
                      <div className="text-danger mt-1 ml-2">
                        {t('emailRequired')}
                      </div>
                    )}
                  </div>
                  <div className="form-group">
                    <label htmlFor="password">{t('password')}</label>
                    <input
                      className="form-control form-control-rounded"
                      type="password"
                      id="password"
                      {...register("password", { required: true })}
                    />
                    {errors.password?.type === 'required' && (
                      <div className="text-danger mt-1 ml-2">
                        {t('passwordRequired')}
                      </div>
                    )}
                    {generalError && (
                      <div className="text-danger mt-1 ml-2">
                        {generalError}
                      </div>
                    )}
                  </div>
                  <button
                    className="btn btn-rounded btn-primary w-100 my-1 mt-2"
                    type="submit"
                    disabled={validButton}
                  >
                    {validButton ? <span><span>&nbsp;</span><div className="spinner-border spinner-border-sm"></div></span> : t('signIn')}
                  </button>
                </form>
                <div className="text-center mt-3">
                  <img src="/assets/images/france.png" onClick={() => langToggle('fr')} alt="Français" name="fr" className="img-fluid p-1" style={{cursor: 'pointer'}}/>
                  <img src="/assets/images/england.png" onClick={() => langToggle('en')} alt="English" name="en" className="img-fluid p-1" style={{cursor: 'pointer'}}/>
                </div>
              </div>
            </div>
            <div
              className="col-md-6 text-center "
              style={{
                backgroundSize: "cover",
                backgroundColor: "rgba(0,0,0)"
              }}
            >
              <div className="pe-3 auth-right">
                <img className="img-fluid p-3" src="/assets/images/logo.png"  />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Signin;
